<template>
  <div style="margin: 15px; margin-right: 30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="130px">
      <el-row>
        <el-form-item label="装货地址" prop="shipperSubdivisionCodeList">
          <el-cascader
            v-model="form.shipperSubdivisionCodeList"
            :options="areaOptions"
            :props="{ value: 'countyCode', label: 'countyName' }"
            clearable
            placeholder="请选择装货地址"
            @change="changeConsignorAreaList" 
          />
        </el-form-item>
        <el-form-item label="装货详细地址" prop="consignorDetailAddress">
          <el-input v-model="form.consignorDetailAddress" placeholder="请输入装货详细地址" />
        </el-form-item>
        <el-form-item label="收货地址" prop="consigneeSubdivisionCodeList">
          <el-cascader
            v-model="form.consigneeSubdivisionCodeList"
            :options="areaOptions"
            :props="{ value: 'countyCode', label: 'countyName' }"
            clearable
            placeholder="请选择收货地址"
            @change="changeConsigneeAreaList" 
          />
        </el-form-item>
        <el-form-item label="收货详细地址" prop="consigneeDetailAddress">
          <el-input v-model="form.consigneeDetailAddress" placeholder="请输入收货详细地址" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { getCommonRouteInfo,addCommonRouteInfo,updateCommonRouteInfo } from '@/api/shipment'
export default {
  name: "DriverCommonRouteInfoAdd",
  props: {
    areaOptions: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {
        userCode: "",
        shipperSubdivisionCodeList: [],
        consignorProvinceCode: "",
        consignorCityCode: "",
        consignorCountyCode: "",
        consignorDetailAddress: "",
        consigneeSubdivisionCodeList: [],
        consigneeProvinceCode: "",
        consigneeCityCode: "",
        consigneeCountyCode: "",
        consigneeDetailAddress: "",
        distance: 0
      },
      rules: {
        shipperSubdivisionCodeList: [
          { required: true, message: "请选择装货地址", trigger: "change" }
        ],
        consignorDetailAddress: [
          { max: 255, message:'长度为255个字符', trigger: 'blur' }
        ],
        consigneeSubdivisionCodeList: [
          { required: true, message: "请选择收货地址", trigger: "change" }
        ],
        consigneeDetailAddress: [
          { max: 255, message:'长度为255个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.form.userCode = this.$route.query.partyCode;
  },
  methods: {
    getInfo(code) {
      this.$refs['form'].resetFields()
      if(code){
        getCommonRouteInfo(code).then(response => {
          this.form = response.data
        })
      }
    },
    funcSubmit() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response = this.form.code?await  updateCommonRouteInfo(this.form): await addCommonRouteInfo(this.form)
          rLoading.close();
          this.$message({ message: response.msg, type: 'success' })
          this.$emit('fatherAddMethod')
        } else {
          return false;
        }
      });
    },
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
    changeConsigneeAreaList() {
      this.form.consigneeProvinceCode = this.form.consigneeSubdivisionCodeList[0];
      this.form.consigneeCityCode = this.form.consigneeSubdivisionCodeList[1];
      this.form.consigneeCountyCode = this.form.consigneeSubdivisionCodeList[2];
    },
    changeConsignorAreaList() {
      this.form.consignorProvinceCode = this.form.shipperSubdivisionCodeList[0];
      this.form.consignorCityCode = this.form.shipperSubdivisionCodeList[1];
      this.form.consignorCountyCode = this.form.shipperSubdivisionCodeList[2];
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}

</style>
